<template>
  <div>
    <el-dialog
      v-model="dialogFormVisible"
      :close-on-click-modal="false"
      :title="title"
      width="80%"
      @close="close(formRef)"
    >
      <el-form ref="formRef" label-width="120px" :model="form" :rules="rules">
        <!-- 门店 -->
        <el-form-item label="门店" prop="branchId">
          <el-select
            v-model="form.branchId"
            placeholder="请选择门店"
            class="fix-width"
            clearable
            :disabled="!!form.rateCodeId"
          >
            <el-option
              v-for="item in branchList"
              :key="item.branchId"
              :label="item.title"
              :value="item.branchId"
            ></el-option>
          </el-select>
        </el-form-item>
        <!-- 酒店 -->
        <el-form-item label="酒店" prop="hotelId">
          <el-select
            v-model="form.hotelId"
            placeholder="请选择酒店"
            class="fix-width"
            clearable
            :disabled="!!form.rateCodeId"
          >
            <el-option
              v-for="item in hotelList"
              :key="item.hotelId"
              :label="item.title"
              :value="item.hotelId"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="标题" prop="title">
          <el-input
            v-model.trim="form.title"
            class="fix-width"
            placeholder="请输入标题"
          />
        </el-form-item>
        <el-form-item label="标题别名" prop="aliasTitle">
          <el-input
            v-model.trim="form.aliasTitle"
            class="fix-width"
            placeholder="请输入标题别名"
          />
        </el-form-item>
        <el-form-item label="类型">
          <el-select v-model="form.typehood">
            <el-option
              v-for="item in typehoodList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="上架状态">
          <el-radio-group v-model="form.step" size="mini">
            <el-radio-button :label="1">未上架</el-radio-button>
            <el-radio-button :label="2">上架</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="备注" prop="text">
          <el-input
            v-model="form.text"
            type="textarea"
            class="fix-width"
            placeholder="请输入备注"
          />
        </el-form-item>
        <el-form-item label="排序">
          <el-input-number v-model="form.order" placeholder="排序" />
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="close(formRef)">取 消</el-button>
        <el-button type="primary" @click="save(formRef)">确 定</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { createRateCode, updateRateCode } from '@/api/room'
import { getAllBranchs } from '@/api/branch'
import { ref, reactive, getCurrentInstance } from 'vue'
import getHotel from '../hotel'
export default {
  name: 'RoomTypeCodeEdit',
  emits: ['fetch-data'],
  setup(_, { emit }) {
    const { proxy } = getCurrentInstance()
    const title = ref('')
    const branchList = reactive([])
    const dialogFormVisible = ref(false)
    const formRef = ref(null)
    const initForm = () => {
      return {
        rateCodeId: '',
        title: '',
        aliasTitle: '',
        branchId: '',
        text: '',
        step: 2,
        order: 1,
        typehood: 1,
      }
    }
    const form = reactive(initForm())
    const { hotelList } = getHotel()
    const typehoodList = [
      {
        label: '个人',
        value: 1,
      },
      {
        label: '协议公司',
        value: 2,
      },
    ]
    const rules = {
      title: [{ required: true, trigger: 'blur', message: '请输入标题' }],
      branchId: [{ required: true, trigger: 'blur', message: '请选择门店' }],
    }
    const getAllBranchList = async () => {
      const res = await getAllBranchs({})
      if (!res) return
      branchList.length = 0
      branchList.push(...res)
    }
    const showEdit = async (row) => {
      if (row && row.rateCodeId) {
        title.value = '修改房价码'
        form.text = row.basic.text
        form.order = row.basic.order
        form.aliasTitle = row.basic.aliasTitle
        form.rateCodeId = row.rateCodeId
        form.title = row.title
        form.step = row.step
        form.typehood = row.typehood
        form.branchId = row.extra.branchId
      } else {
        title.value = '新增房价码'
      }
      getAllBranchList()
      dialogFormVisible.value = true
    }
    const formReset = (formRef) => {
      if (!formRef) return
      formRef.resetFields()
      Object.assign(form, initForm())
    }
    const close = (formRef) => {
      formReset(formRef)
      dialogFormVisible.value = false
    }
    const save = (formRef) => {
      if (!formRef) return
      formRef.validate(async (valid) => {
        if (valid) {
          const rateCodeId = form.rateCodeId
          const data = Object.assign({}, form)
          proxy.$baseConfirm(
            `你确定要${rateCodeId ? '修改' : '新增'}房价码吗`,
            null,
            async () => {
              rateCodeId
                ? await updateRateCode(data)
                : await createRateCode(data)
              proxy.$baseMessage(
                `${rateCodeId ? '修改' : '新增'}房价码成功`,
                'success',
                false,
                'vab-hey-message-success'
              )
              emit('fetch-data')
              close(formRef)
            }
          )
        } else {
          return false
        }
      })
    }
    return {
      title,
      branchList,
      hotelList,
      formRef,
      form,
      rules,
      typehoodList,
      dialogFormVisible,
      showEdit,
      getAllBranchList,
      close,
      save,
    }
  },
}
</script>

<style lang="scss" scoped>
@mixin size($scale: 1, $type: small) {
  @if $type == large {
    width: 343px * $scale;
  } @else {
    width: 167px * $scale;
  }
  height: 167px * $scale;
}
.avatar-uploader {
  .avatar {
    border-radius: 6px;
    transition: all 0.3s ease-in-out;
    @include size;

    &.large {
      @include size(1, large);
    }
  }
}
.icon_avatar {
  width: 50px;
  height: 50px;
}
.avatar-uploader-icon {
  border: 1px dashed #c0ccda;
  background-color: #fbfdff;
  border-radius: 6px;
  font-size: 28px;
  color: #8c939d;
  width: 148px;
  height: 148px;
  line-height: 148px;
  text-align: center;
}
.tags {
  margin-bottom: 5px;
}
.tags + .tags,
.tags + .button-new-tag {
  margin-left: 10px;
}
.button-new-tag {
  // margin-left: 10px;
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}
.input-new-tag {
  width: 90px;
  margin-left: 10px;
  vertical-align: bottom;
}
.disabled .el-upload--picture-card {
  display: none;
}
.fix-width {
  width: 500px;
}
.mb-10 {
  margin-bottom: 10px;
}
.tips {
  color: #aaaaaa;
  margin-left: 50px;
}
.el-icon-circle-plus-outline,
.el-icon-remove-outline {
  font-size: 32px;
  vertical-align: middle;
  cursor: pointer;
}

.el-icon-circle-plus-outline {
  color: #409eff;
}

.el-icon-remove-outline {
  color: #f56c6c;
  margin-left: 15px;
}

.mr-10 {
  margin-right: 10px;
}
.mb-10 {
  margin-bottom: 10px;
}
</style>
